export default require("./node_modules/lodash/lodash.js");